import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import "./login.css"
import { useDispatch } from 'react-redux'
import { toast  , ToastContainer} from 'react-toastify'
import { forgotPasswordApi } from '../../redux/apiCalls/passwordApiCall'


function ForgetPassword() {

   const [email , setEmail] = useState("")
   const dispatch = useDispatch()

   // Form Submit Handler
const formSubmitHandler = async (e) => {
  e.preventDefault();

  if (email.trim() === "") return toast.error("Email is required");

  try {
    await dispatch(forgotPasswordApi(email)); // ✅ wait for the thunk
  } catch (err) {
    console.log(err); // optional
  }
};
  return (
    <main className="login-page">
<ToastContainer theme="colored"  position="top-center" />
      <div className="login-card">
        <h1 className="login-title">Forget Password</h1>
        {/* <p className="login-subtitle">Use your account to access the portal</p> */}

        <form onSubmit={formSubmitHandler} className="login-form">
          <div className="login-field">
          <div> </div>
            <input
              id="login-email"
              type="email"
              placeholder="enter your email"
              value={email}
              onChange={(e)=> setEmail(e.target.value)}
            />
          </div>
         
          <button type="submit" className="login-submit">
            Submit
          </button>
        </form>

       
      </div>
    </main>
  )
}

export default ForgetPassword
